import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      // Show sticky CTA after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-text-primary/10 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-50 sm:hidden transform transition-transform duration-300 translate-y-0" data-id="element-181">
      <a href="https://myschoolofbusiness.com/cart/47422073733314:1" target="_blank" rel="noopener noreferrer" className="w-full py-4 bg-accent text-white rounded-xl font-bold text-lg shadow-lg flex items-center justify-center gap-2" data-id="element-182">
        QUIERO ACCEDER POR $6.39
      </a>
    </div>;
}